export default __webpack_public_path__ + "static/media/bird4.d7230082.svg";